import React, { ReactNode } from "react"
import useWindowSize from "hooks/useWindowSize"

interface GridLayoutProps {
    title?: ReactNode
    content?: ReactNode
    sliderContent?: ReactNode
    className?: string
}

const GridLayout: React.FC<GridLayoutProps> = ({
    title,
    content,
    sliderContent,
    className,
}) => {
    const { isDesktop } = useWindowSize()

    // If not desktop, use a different layout
    if (!isDesktop) {
        return (
            <div className={`w-full flex flex-col gap-4 px-4 ${className}`}>
                {title && <div className="w-full">{title}</div>}
                {content && <div className="w-full">{content}</div>}
                {sliderContent && <div className="w-full">{sliderContent}</div>}
            </div>
        )
    }

    // Common container style for consistent alignment with header and action card
    const containerClass = "w-full max-w-screen-xl mx-auto px-4 md:px-6 lg:px-8"

    // For standalone content layouts
    if (content && !sliderContent) {
        return (
            <div className={`${containerClass} ${className}`}>
                <div className="flex flex-wrap">
                    {/* Title section */}
                    <div className="w-full md:w-1/3 lg:w-1/4 pr-4">
                        <div className="h-full">{title}</div>
                    </div>

                    {/* Content section */}
                    <div className="w-full md:w-2/3 lg:w-3/4">
                        <div className="h-full">{content}</div>
                    </div>
                </div>
            </div>
        )
    }

    // For slider layouts or combined layouts
    return (
        <div className={`${containerClass} ${className}`}>
            <div className="flex flex-wrap">
                {/* Title section */}
                <div className="w-full md:w-1/3 lg:w-1/4 pr-4">
                    <div className="h-full">{title}</div>
                </div>

                {/* Content and Slider container */}
                <div className="w-full md:w-2/3 lg:w-3/4">
                    <div className="flex flex-wrap">
                        {/* Content section when present */}
                        {content && (
                            <div
                                className={`w-full ${sliderContent ? "lg:w-1/2 lg:pr-3" : "lg:w-full"}`}
                            >
                                <div className="h-full">{content}</div>
                            </div>
                        )}

                        {/* Slider section */}
                        {sliderContent && (
                            <div
                                className={`w-full ${content ? "lg:w-1/2 lg:pl-3" : "lg:w-full"}`}
                            >
                                <div className="h-full">{sliderContent}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GridLayout
